/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDownloadCloud(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M8.748 3.005a8.453 8.453 0 013.684.701 8.376 8.376 0 013.008 2.225A8.279 8.279 0 0117 8.674h.642m0 0c1.172 0 2.314.368 3.26 1.053a5.471 5.471 0 012.006 2.762 5.421 5.421 0 01-.032 3.406 5.474 5.474 0 01-2.057 2.724.75.75 0 11-.857-1.231 3.974 3.974 0 001.494-1.978c.273-.798.28-1.66.024-2.463a3.972 3.972 0 00-1.457-2.005 4.054 4.054 0 00-2.38-.768h-1.202a.75.75 0 01-.726-.562 6.774 6.774 0 00-1.414-2.705 6.876 6.876 0 00-2.47-1.826 6.954 6.954 0 00-6.01.214A6.859 6.859 0 003.49 7.29a6.76 6.76 0 00-1.214 2.798 6.723 6.723 0 00.143 3.04c.28.99.783 1.905 1.472 2.676a.75.75 0 01-1.118 1 8.277 8.277 0 01-1.797-3.268A8.223 8.223 0 01.8 9.82 8.26 8.26 0 012.284 6.4a8.359 8.359 0 012.84-2.432 8.446 8.446 0 013.624-.962m3.171 8.5a.75.75 0 01.75.75v6.698l2.539-2.511a.75.75 0 011.055 1.066l-3.816 3.775a.75.75 0 01-1.055 0l-3.816-3.775a.75.75 0 111.055-1.066l2.538 2.511v-6.697a.75.75 0 01.75-.75z'
      />
    </svg>
  );
}

export default SvgDownloadCloud;
